import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgClock = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 64 64"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="hsl(var(--system-icon-background-default))"
        d="M59.976 5.776c-23.96-8.65-46.853-3.604-55.547 0-8.021 23.667-3.342 45.442 0 53.371 23.783 8.79 46.78 3.662 55.547 0 7.288-22.036 3.037-44.762 0-53.37"
      />
      <g
        stroke="hsl(var(--system-icon-foreground))"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        clipPath="url(#Clock_svg__a)"
      >
        <path
          fill="hsl(var(--system-icon-white))"
          d="M40.67 13.5H23.33c-6.042 0-9.83 4.279-9.83 10.333v16.335c0 6.054 3.768 10.332 9.83 10.332h17.336c6.062 0 9.834-4.278 9.834-10.332V23.833c0-6.054-3.772-10.332-9.832-10.332"
        />
        <path d="M38.783 36.036 32 31.99v-8.722" />
      </g>
      <defs>
        <clipPath id="Clock_svg__a">
          <path fill="hsl(var(--system-icon-white))" d="M8 8h48v48H8z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default SvgClock;
